import Vue from 'vue'
import Vuex from 'vuex'
// import Gql from 'graphql-tag'
// import Apollo from './apolloClient'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // Leverage the below structure for a single nav that leads back to home.
        // BeautyBody.Cosmetics => {
        //   cuteLipstickColorCaca x kylieJenner x kylieCosmetics
        //   }
        activeCelebPageId: null,
        celebs: {
            celebID: {
                birthName: 'Kylie Jenner',
                birthDate: "1997-08-10",
                age: 22,
                birthPlace: 'Calabasas, CA',
                networth: 1000000000,
                height: {
                    feet: 5,
                    inches: 7
                },
                knownFame: {
                    socialite: './actor'
                }
            },
            companySpecificData: {
                ranking: 'social[1]',
                linkUri: 'https://famemadesense.com/kylie-jenner'
            },
            EndorsedProducts: {
                productID1: {
                    productLinkPage: 'fms.com/quav-classy-summer-sun-glasses'
                }
            }
        },
        // sort by post date, the product is the article.
        products: {
            productID: {
                imgs: ['heresOne.jpg', 'heresAnotherOne.jpg'],
                // celebs Filters found on this product
                celebEndorserIds: [
                    'celebID-Lebron',
                    'celebID-DjKhaled'
                ],
                // Brand Filter found on this product(typically should be one)
                licensingBrand: 'brandID-Nike',

                postDate: 'submittionDate',
                category: {
                    primary: ['Sports', 'Fashion'],
                    subcategories: ['basketball', 'footwear']
                },
                ipSumArticleId: 0
            }
        },
        articles: [{
            articleId: 'Off-White-Air-Forces',
            headline: 'Lebron steps out off court in Nike "Off-White" Air Force Ones',
            content: 'Whole lotta ipSum here and there. Lots of ad vice and the hard work still needs to be done by you.',
            affiliateLinks: [
                'nike.com/affiliate_cookie',
                'amazon.com/affiliate_cookie'
            ]
        }],
        categories: [{
                title: 'Body, Beauty and Bath',
                subCategories: [
                    'Cosmetics',
                    'fragrances'
                ]
            },
            {
                title: 'Fashion',
                subCategories: [
                    'Footwear',
                    'Accesories'
                ]

            },
            {
                title: 'Entertainment',
                subCategories: [
                    'Music',
                    'Movies'
                ]

            }
        ]
    },
    // mutations: {
    //     setActiveUser(state, payload) {
    //         state.activeCelebPageId = payload.id
    //     }
    // },
    // actions: {},
    // getters: {
    //     // Retrieve the given category content
    //     activeCeleb({
    //         celebs,
    //         activeCelebPageId
    //     }) {
    //         return celebs.find((u) => u.celebID.birthName === activeCelebPageId) || null
    //     },
    //     categories({
    //         categories
    //     }){
    //         let categoriesLoaded = []
    //         let item = 0
    //         categories.forEach(pushArray)
    //         pushArray() {
    //             categoriesLoaded.push(item.title)
    //         }
    //         return categoriesLoaded[0]
    //     }
    // }
})
